import { Component, OnInit, ElementRef, AfterContentChecked, ContentChild } from '@angular/core';
import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'c-input input'
})
export class InputReferenceDirective { }

@Component({
  selector: 'c-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit, AfterContentChecked {

  private inputElement: HTMLInputElement;
  isShowErrors: boolean;
  isOnFocus: boolean;
  isRequired: boolean;
  errorType: string;
  errorParams: any;

  @ContentChild(InputReferenceDirective, { read: NgControl, static: true }) control: NgControl;
  @ContentChild(InputReferenceDirective, { read: ElementRef, static: true }) inputElementRef: ElementRef;

  constructor() { }

  ngOnInit() {
    this.inputElement = this.inputElementRef.nativeElement;
    this.createInputListners();
  }

  ngAfterContentChecked() {
    this.checkChanges();
  }

  checkChanges() {
    this.checkIsRequired();
    this.checkErrors();
  }

  createInputListners() {
    this.inputElement.addEventListener('focus', () => {
      this.isOnFocus = true;
      this.hideErrors();
    });
    this.inputElement.addEventListener('focusout', () => {
      this.isOnFocus = false;
      this.checkChanges();
    });
  }

  private checkIsRequired() {
    const control: any = this.control;
    if (control && control.control && control.control.validator) {
      const validators = control.control.validator('');

      if (validators && validators.required) {
        this.isRequired = true;
        this.inputElement.setAttribute('required', '');
      } else {
        this.isRequired = false;
        this.inputElement.removeAttribute('required');
      }
    }
  }

  private checkErrors() {
    if (this.control && this.control.invalid && this.control.touched) {
      this.errorType = Object.keys(this.control.errors)[0];
      this.errorParams = this.getErrorParameters(this.errorType);
      this.isShowErrors = true;
    } else {
      this.isShowErrors = false;
    }
  }

  private hideErrors() {
    this.isShowErrors = false;
  }

  private getErrorParameters(errorType: string) {
    let params: any;
    switch (errorType) {
      case 'minlength':
        params = {
          value1: this.control.errors.minlength.requiredLength
        };
        break;
    }

    return params;
  }

}


